import tapTabLogo from '../../../assets/images/TapTabLargeLogoWhite.png';

interface RestaurantWizardHeaderProps {
  title: string;
}

const RestaurantWizardHeader = ({ title }: RestaurantWizardHeaderProps) => (
  <div className="restaurant-wizard-header">
    <div className="restaurant-wizard-header-badge">
      <img
        src={tapTabLogo}
        alt=""
        className="restaurant-wizard-header-logo"
        aria-hidden
      />
      <h1 className="restaurant-wizard-header-title">{title}</h1>
    </div>
  </div>
);

export default RestaurantWizardHeader;
